import { createContext } from "react"

export type Action = {
    projectId: number
    actionId: number
    date: Date
    workstream: string
    workstreamId: number
    workPackage: string
    workPackageId: number
    raisedBy: string
    description: string
    owner: string
    userId: string
    dueDate: Date
    status: "Closed" | "Cancelled" | "Open"
    notes: string
    seen: boolean
    acknowledged: boolean
}

interface ActionContextProps {
    dialogOpen: boolean;
    setDialogOpen: (open: boolean) => void;
    actionTableDemoContent: Action[];
    setActionTableDemoContent: (content: Action[]) => void;
    showPopup: (action: Action) => void;
    demoMode: boolean;
    setDemoMode: (mode: boolean) => void;
    rowSelection: {};
    setRowSelection: React.Dispatch<React.SetStateAction<{}>>;
    addAction: () => void;
}

export const ActionContext = createContext<ActionContextProps>({
    dialogOpen: false,
    setDialogOpen: () => {},
    actionTableDemoContent: [],
    setActionTableDemoContent: () => {},
    showPopup: () => {},
    demoMode: false,
    setDemoMode: () => {},
    rowSelection: {},
    setRowSelection: () => {},
    addAction: () => {},
});